import React from 'react';
import styled from 'styled-components/macro';
import { Box } from 'modsy-ui-kit';

import NoImage from 'static/images/studio/product-details/no-image-placeholder@2x.svg';

const Container = styled(Box)`
  background: #f6f6f6;
  height: 100%;
  position: relative;
  width: 100%;
`;

const NoImagePicture = styled.img`
  height: 50%;
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export default (props) => (
  <Container>
    <NoImagePicture src={NoImage} alt='no-image' />
  </Container>
);
